module.exports = __webpack_public_path__ + "static/img/bgRoll3.e684785e.png";